// Preview fragment builder for sandboxed HTML rendering.
// Example: buildPreviewHtmlFragment("<div>Hi</div>").

const JS_URL_ATTRIBUTES = new Set(['href', 'src', 'action', 'formaction', 'xlink:href'])

export type PreviewBuildResult = {
  fragment: DocumentFragment
  removedScriptCount: number
  removedUnsafeAttributeCount: number
}

// Parse raw HTML text and return a detached fragment for preview rendering.
export function buildPreviewHtmlFragment(html: string): PreviewBuildResult {
  const parser = new DOMParser()
  const parsed = parser.parseFromString(html, 'text/html')
  const fragment = document.createDocumentFragment()
  let removedScriptCount = 0
  let removedUnsafeAttributeCount = 0

  for (const script of parsed.querySelectorAll('script')) {
    script.remove()
    removedScriptCount += 1
  }

  for (const element of parsed.body.querySelectorAll('*')) {
    for (const attribute of Array.from(element.attributes)) {
      if (attribute.name.toLowerCase().startsWith('on')) {
        element.removeAttribute(attribute.name)
        removedUnsafeAttributeCount += 1
        continue
      }

      if (JS_URL_ATTRIBUTES.has(attribute.name.toLowerCase()) && /^\s*javascript:/i.test(attribute.value)) {
        element.removeAttribute(attribute.name)
        removedUnsafeAttributeCount += 1
      }
    }
  }

  // Copy parsed nodes into current document before replacing preview children.
  for (const node of parsed.body.childNodes) {
    fragment.appendChild(document.importNode(node, true))
  }

  return {
    fragment,
    removedScriptCount,
    removedUnsafeAttributeCount,
  }
}
